import { render, staticRenderFns } from "./MemberLevelRules.vue?vue&type=template&id=5b893665&scoped=true"
import script from "./MemberLevelRules.vue?vue&type=script&lang=js"
export * from "./MemberLevelRules.vue?vue&type=script&lang=js"
import style0 from "./MemberLevelRules.vue?vue&type=style&index=0&id=5b893665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b893665",
  null
  
)

export default component.exports